import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import AnchorLink from '../../../Buttons/ButtonLink/AnchorLink'

import Typography from '../../../Typography/Typography'

import hocCopyright from './hocCopyright'

import { documentSlugs } from 'components/Modal/DocumentPopupWindow/slugs'

const WEB_PORTAL_URL = process.env.REACT_APP_WEB_PORTAL_URL

import './Copyright.scss'

const Copyright = ({ setSlug }) => {
    const intl = useIntl()

    const currentYear = new Date().getFullYear()

    //TODO href AnchorLinks

    return (
        <Container fluid className={'copyright d-flex'}>
            <Typography variant={'h4'} className={'copyright--companies-desktop'}>
                {intl.formatMessage({ id: 'footer.copyright.cinestar' }, { year: currentYear })}
            </Typography>
            <div className="copyright--links d-flex">
                <AnchorLink className={'p-0'} href={'https://cinexpress.cz/'} target="_blank">
                    <Typography variant={'badge'}>
                        {intl.formatMessage({ id: 'footer.copyright.advertising' })}
                    </Typography>
                </AnchorLink>
                <AnchorLink className={'p-0'} onClick={() => setSlug({ slug: documentSlugs.regulations })}>
                    <Typography variant={'badge'}>
                        {intl.formatMessage({ id: 'footer.copyright.regulations' })}
                    </Typography>
                </AnchorLink>
                <AnchorLink
                    className={'p-0'}
                    href={`${WEB_PORTAL_URL}podminky-zpracovani-osobnich-udaju/`}
                    target="_blank"
                >
                    <Typography variant={'badge'}>{intl.formatMessage({ id: 'footer.copyright.terms' })}</Typography>
                </AnchorLink>
                <AnchorLink className={'p-0'} onClick={() => setSlug({ slug: documentSlugs.conditions })}>
                    <Typography variant={'badge'}>
                        {intl.formatMessage({ id: 'footer.copyright.conditions' })}
                    </Typography>
                </AnchorLink>
            </div>
            <div className="copyright--companies-desktop d-flex align-items-center justify-content-end gap-3">
                <Typography variant={'h4'}>{intl.formatMessage({ id: 'footer.copyright.designBy' })}</Typography>
                <img src={'images/symbio.svg'} alt={'Symbio Logo'} />
            </div>

            <div className="copyright--companies-mobile d-flex">
                <Typography variant={'h4'}>
                    {intl.formatMessage({ id: 'footer.copyright.cinestar' }, { year: currentYear })}
                </Typography>
                <div className="d-flex align-items-center justify-content-end gap-3">
                    <Typography variant={'h4'}>{intl.formatMessage({ id: 'footer.copyright.designBy' })}</Typography>
                    <img src={'images/symbio.svg'} alt={'Symbio Logo'} />
                </div>
            </div>
        </Container>
    )
}

export default hocCopyright(Copyright)
